var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"img-btn nav-btn",on:{"click":function($event){return _vm.$emit('download')}}},[_c('fa-icon',{attrs:{"icon":"download"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }